import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class AsyncDataService {

  constructor(private http: HttpClient) {
  }

  public getPostalCodeDesignation(postalCode4: string, postalCode3: string) {
    return this.http.get("api/AsyncData/GetPostalDesignation", {params: { postalCode4: postalCode4, postalCode3: postalCode3 }, responseType : 'text' });
  }
}
